"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var ErrorMessage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ErrorMessage, _PureComponent);

  function ErrorMessage() {
    (0, _classCallCheck2.default)(this, ErrorMessage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ErrorMessage).apply(this, arguments));
  }

  (0, _createClass2.default)(ErrorMessage, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation.save." + suffix;
    }
  }, {
    key: "getLastSaveAt",
    value: function getLastSaveAt() {
      var lastSaveAt = this.props.lastSaveAt;

      if (lastSaveAt) {
        var timeString = _I18n.default.moment(lastSaveAt).format('h:mm a');

        return _react.default.createElement(_FormattedReactMessage.default, {
          message: this.langKey('lastSuccessfulSave'),
          options: {
            timeString: timeString
          }
        });
      }

      return _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('noChangesSaved')
      });
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(hasValidationErrors) {
      var savingRecentError = this.props.savingRecentError;

      if (hasValidationErrors) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('errorMessage.fixValidationErrors')
        });
      }

      switch (savingRecentError.status) {
        case 0:
          return _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('errorMessage.changesNotSaved')
          });

        case 400:
          return _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('errorMessage.fixValidationErrors')
          });

        case 422:
          return _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('errorMessage.fixValidationErrors')
          });

        case 500:
          return _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('errorMessage.failedToSaveChanges')
          });

        default:
          return _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
            message: 'error'
          }), "` $", savingRecentError.status, ": $", savingRecentError.message, ".`");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          lastSaveAt = _this$props.lastSaveAt,
          hasValidationErrors = _this$props.hasValidationErrors;
      var errorMessage = this.getErrorMessage(hasValidationErrors);
      var lastSaveAtMessage = this.getLastSaveAt(lastSaveAt);

      var title = _react.default.createElement("div", null, errorMessage, _react.default.createElement("br", null), lastSaveAtMessage);

      return _react.default.createElement(_UITooltip.default, {
        placement: "bottom",
        title: title
      }, _react.default.createElement("span", null, _react.default.createElement(_UIIcon.default, {
        name: "remove"
      }), _react.default.createElement("span", {
        className: "secondary-navigation-saving__info-text m-left-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('errorMessage.errorSavingChanges')
      }))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        hasValidationErrors: _react.PropTypes.bool,
        lastSaveAt: _react.PropTypes.number,
        savingRecentError: _react.PropTypes.object
      };
    }
  }]);
  return ErrorMessage;
}(_react.PureComponent);

exports.default = ErrorMessage;
module.exports = exports.default;